import React from 'react';
import { Zap, ShieldCheck, Clock } from 'lucide-react';
import { whyChoose, company } from '../mock';

const iconMap = { Zap, ShieldCheck, Clock };

const WhyChooseUs = () => {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading font-bold text-slate-900 text-3xl md:text-4xl">
            Why Choose {company.name}?
          </h2>
          <p className="mt-4 text-slate-500 text-lg">
            We're committed to providing exceptional technical support that keeps your business running smoothly.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {whyChoose.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.title}
                className="group bg-white border border-slate-100 rounded-2xl p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors">
                  <Icon size={26} />
                </div>
                <h3 className="mt-6 font-heading font-semibold text-slate-900 text-xl">{item.title}</h3>
                <p className="mt-3 text-slate-500 leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
